import { apiMiddleware } from '../services/apiMiddleware'

// Utility function to clear all auth tokens and redirect to login
export const clearAuthAndRedirect = () => {
  localStorage.removeItem('AccessToken')
  localStorage.removeItem('RefreshToken')
  localStorage.removeItem('UserId')
  window.location.href = '/login'
}

// Helper function to get current access token
const getAccessToken = (): string | null => {
  return localStorage.getItem('AccessToken')
}

// Legacy headers for backward compatibility
export const Header = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
  Authorization: getAccessToken(),
  org: localStorage.getItem('org')
}

export const Header1 = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
  Authorization: getAccessToken()
}

// Legacy fetchData function - now uses apiMiddleware internally
// This maintains backward compatibility while using the new middleware
export async function fetchData(url: any, method: any, data = '', header: any) {
  try {
    const options: RequestInit = {
      method,
      headers: header,
    }
    
    if (data && method !== 'GET') {
      options.body = data
    }

    return await apiMiddleware.makeRequest(url, options)
  } catch (error) {
    console.error('fetchData error:', error)
    throw error
  }
}
